import { MenuItem } from '@material-ui/core';
import { FormikTextField } from '@superdispatch/forms';
import { Inline } from '@superdispatch/ui';
import { Box, TextBox } from '@superdispatch/ui-lab';
import { DateTime } from 'luxon';
import { useMemo } from 'react';

function formatDay(day: number) {
  return day === 0 ? 'Today' : day === 1 ? 'Tomorrow' : `${day} days`;
}

export function AdvancedSearchDateField() {
  const today = useMemo(() => DateTime.local().startOf('day'), []);
  return (
    <FormikTextField
      select={true}
      fullWidth={true}
      name="search_criteria.ready_within_days"
      parse={(event) =>
        event.target.value === '' ? undefined : event.target.value
      }
      SelectProps={{
        displayEmpty: true,
        renderValue: (value) => {
          if (value) {
            return formatDay(Number(value));
          }
          return 'Any Date';
        },
      }}
    >
      <MenuItem value="">Any Date</MenuItem>

      {[0, 1, 2, 3, 4, 5, 6, 7, 14].map((day) => (
        <MenuItem key={day} value={day}>
          <Inline>
            <Box width="85px">{formatDay(day)}</Box>
            <TextBox color="secondary">
              {today.plus({ days: day }).toFormat('EEE, LLL d')}
            </TextBox>
          </Inline>
        </MenuItem>
      ))}
    </FormikTextField>
  );
}
